import { PaymentPartnerType } from '../../codegen/transactions';
import { PAYMENT_PARTNER_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';
import { PaymentPartnerIcon } from '../icons/PaymentPartnerIcon';

type PaymentPartnerRepresentationProps = {
  paymentPartner: PaymentPartnerType;
  additionalClassName?: string;
};

export const PaymentPartnerRepresentation = ({
  paymentPartner,
  additionalClassName,
}: PaymentPartnerRepresentationProps) => {
  const className = `display-flex gap-5 align-items-center ${additionalClassName ?? ''}`;
  return (
    <div className={className}>
      <PaymentPartnerIcon
        paymentPartner={paymentPartner}
        className="height-20 margin-bottom-0"
      />
      <span className="ellipsis-1">
        {PAYMENT_PARTNER_TO_TRANSLATION_KEY[paymentPartner]}
      </span>
    </div>
  );
};
